/*
 * @Author: wzc
 * @Date: 2024-05-08 10:42:36
 * @LastEditors: wzc
 * @LastEditTime: 2024-05-15 19:11:02
 * vue2.0 点击移动事件：兼容touch事件和鼠标事件
 * 点击图片即可以移动图片，松开时图片不会移动；
 */
export default {
  props: {},
  data() {
    return {
      draggableGroupRefsName: '', // 拖拽最外层dom 的refs name, 在这里定义，.vue文件中赋值
      draggableGroupDom: null, // 通过refs[draggableGroupRefsName] 获取到的 dom 对象
      draggableStatus: null, // 拖拽的状态： ['touchmove_open(开启拖拽)']
      touchStartTime: 0, // 按下的时间
      setTimerId: null, // 存储是否长按事件的 timerId
      userDeviceType: '', // 区分用户设备的字段, 移动端和pc端移动的原因不一样的
      // curPicItem: null, // 选中和拖拽的元素，在.vue文件中定义赋值
    }
  },
  created() {
    console.debug(`init draggable`)
  },
  mounted() {
    if (this.draggableGroupRefsName) {
      this.draggableGroupDom = this.$refs[this.draggableGroupRefsName]
      console.debug('draggable:', this.draggableGroupDom)
      this.initDraggableTriggerEvent(this.draggableGroupDom)
    }
  },
  beforeDestroy() {
    console.debug('注销监听事件')
    const touchEventArr = this.touchEventArr
    this.draggableGroupDom.removeEventListener(
      touchEventArr[0],
      this.touchStartAddEventFun
    )
    this.draggableGroupDom.removeEventListener(
      touchEventArr[1],
      this.touchMoveAddEventFun
    )
    this.draggableGroupDom.removeEventListener(
      touchEventArr[2],
      this.touchUpAddEventFun
    )
    this.draggableGroupDom.removeEventListener('click', this.clickAddEventFun)

    // 为document添加滚动事件
    document.removeEventListener('wheel', this.scrollBarWheelAddEventFun)
  },
  methods: {
    initDraggableTriggerEvent(dom) {
      // 初始化拖拽触发监听事件，监听是否要开启拖拽事件
      if (!dom) return

      let touchEventArr = []
      //   判断是否支持 touch 事件
      if ('ontouchstart' in window || navigator.maxTouchPoints) {
        // 移动设备上的代码
        this.userDeviceType = 'mobile'
        touchEventArr = ['touchstart', 'touchmove', 'touchend']
      } else {
        // PC 上的代码
        this.userDeviceType = 'pc'
        touchEventArr = ['mousedown', 'mousemove', 'mouseup']
      }
      this.touchEventArr = touchEventArr
      console.debug('initDraggableTriggerEvent', dom.offsetWidth)
      dom.addEventListener(touchEventArr[0], this.touchStartAddEventFun, {
        passive: false,
      })
      dom.addEventListener(touchEventArr[1], this.touchMoveAddEventFun, {
        passive: false,
      })
      dom.addEventListener(touchEventArr[2], this.touchUpAddEventFun, {
        passive: false,
      })
      dom.addEventListener('click', this.clickAddEventFun, { passive: false })

      // 为document添加滚动事件
      dom.addEventListener('wheel', this.scrollBarWheelAddEventFun)

      // 关闭 ipad 默认弹窗事件，比如长按会触发浏览器默认弹窗
      dom.addEventListener(
        'contextmenu',
        function (e) {
          e.preventDefault()
        },
        false
      )
    },
    touchStartAddEventFun(event) {
      // 记录触摸开始的时间
      console.debug('touchStart', event, this.userDeviceType)
      this.draggableStatus = 'touch_start'
      this.draggableToPicItemChangeEvent(event, 'click')
      if (this.userDeviceType === 'pc') {
        if (event.offsetX < 0 || event.offsetY < 0) {
          this.initStartOffsetArr = null //不知道为啥偶尔会有负数，正常都是应该大于0的
        } else {
          this.initStartOffsetArr = [event.offsetX, event.offsetY] // 记录按下时的坐标
        }
      } else {
        // pc和移动端的取值字段和值对应屏幕的位置不一样, getBoundingClientRect()得到的值也不一样
        let touchTarget = event.target
        let picContainerDom = touchTarget.closest('.picContainer')

        const { left: workspaceLeft, top: workspaceTop } =
          this.draggableGroupDom.getBoundingClientRect() //得到的值是相对于屏幕而不是父级中的偏移量值，所以需要减差值
        const { left: curPicItemLeft, top: curPicItemTop } =
          picContainerDom.getBoundingClientRect()
        const touch = event.targetTouches[0]
        this.curPicItemInitOffsetWHArr = [
          curPicItemLeft - workspaceLeft,
          curPicItemTop - workspaceTop,
        ]
        console.debug(
          'curPicItemInitOffsetWHArr:',
          picContainerDom.getBoundingClientRect()
        )
        if (touch.clientX < 0 || touch.clientY < 0) {
          this.initStartOffsetArr = null //不知道为啥偶尔会有负数，正常都是应该大于0的
        } else {
          this.initStartOffsetArr = [touch.clientX, touch.clientY]
        }
      }
      if (!this.initStartOffsetArr) return
      // 此时开启拖拽事件，要将元素的 draggable 属性打开
      let touchTarget = event.target
      // 使用closest方法查找最近的匹配的父级元素
      this.picContainerDom = touchTarget.closest('.picContainer')
    },
    touchMoveAddEventFun(event) {
      // 按住移动了
      if (this.picContainerDom && this.initStartOffsetArr) {
        console.debug('touchMove', event)
        this.draggableStatus = 'touchmove_open' //这状态在.vue视图中用到，很重要
        //   this.draggableEvent_cancel_setTimerEvent('move', event)
        this.touchMoveFun(event)
      }
    },
    touchMoveFun(event) {
      // console.debug(
      //   'move',
      //   event,
      //   this.draggableGroupDom.getBoundingClientRect(),
      //   this.picContainerDom
      // )
      event.preventDefault()
      if (this.initStartOffsetArr && this.initStartOffsetArr.length === 2) {
        let diffX = 0,
          diffY = 0
        if (this.userDeviceType === 'pc') {
          const { left: canvasLeft, top: canvasTop } =
            this.draggableGroupDom.getBoundingClientRect()
          const offsetX = event.clientX - canvasLeft
          const offsetY = event.clientY - canvasTop

          // console.debug(
          //   'picContainerDom:',
          //   this.picContainerDom,
          //   offsetX,
          //   offsetY,
          //   targetWidth,
          //   targetHeight,
          //   this.initStartOffsetArr
          // )
          diffX = offsetX - this.initStartOffsetArr[0]
          diffY = offsetY - this.initStartOffsetArr[1]
          // const styleItem = {
          //   left: `${this.boundaryRange(diffX, targetWidth, canvasWidth)}px`,
          //   top: `${this.boundaryRange(diffY, targetHeight, canvasHeight)}px`,
          // }
        } else {
          if (this.curPicItemInitOffsetWHArr) {
            diffX =
              this.curPicItemInitOffsetWHArr[0] -
              (this.initStartOffsetArr[0] - event.targetTouches[0].clientX)
            diffY =
              this.curPicItemInitOffsetWHArr[1] -
              (this.initStartOffsetArr[1] - event.targetTouches[0].clientY)
          }
        }
        const styleItem = {
          left: `${diffX}px`,
          top: `${diffY}px`,
          zIndex: this.curPicItem.styleItem.zIndex,
        }
        // 移动时，计算元素移动的style，同步到 fileData 和 curPicItem 中
        this.draggableToPicItemChangeEvent(null, 'click', styleItem)
      }
    },
    touchUpAddEventFun(event) {
      console.debug('touchUp', event)
      event.preventDefault()
      // 移动结束
      this.picContainerDom = null //将刚刚拖拽的对象重置null
      this.draggableEvent_cancel_setTimerEvent('up', event)
    },
    draggableEvent_cancel_setTimerEvent(state, event) {
      console.debug('setTimerEvent:', event, state)
      if (state === 'up') {
        // touch都停留在 click 样式
        this.draggableToPicItemChangeEvent(event, 'click')
        this.initStartOffsetArr = null
      }
      this.draggableStatus = null
    },
    boundaryRange(num, selfNum, maxNum) {
      // 画板安全范围，但是央视不要，因此注释
      if (num > 0 && num < maxNum - selfNum) {
        return num
      } else if (num <= 0) {
        return 0
      } else if (num >= maxNum - selfNum) {
        return maxNum - selfNum
      } else {
        console.debug('不符合条件')
      }
    },
    clickAddEventFun(event) {
      if (this.draggableStatus) {
        // 阻止 click 事件的默认行为
        event.preventDefault()
        console.debug('阻止 click 事件的默认行为')
        // 执行特殊的快速点击行为
        // ...
        // isMouseDown = false;
      } else {
        // 执行常规的点击行为
        // ...
      }
    },
    scrollBarWheelAddEventFun(event) {
      // 如果当前正在移动，阻止滚动事件
      if (this.draggableStatus) {
        event.preventDefault()
      }
      // 你可以在这里添加其他的滚动处理逻辑
    },
  },
}
